import React, { useState } from "react";
import { PaperAirplaneIcon } from "@heroicons/react/24/solid";

const PeopleSearchBox = ({ onSearch }) => {
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch(query.trim());   // delegate to parent (CodiOS)
      setQuery("");
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="w-full flex items-center rounded-xl border border-gray-300 bg-white px-3 py-2 shadow-sm focus-within:ring-2 focus-within:ring-black/10"
    >
      <input
        type="text"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder="Find me a designer in SF with Figma…"
        className="flex-1 bg-transparent text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none"
        disabled={loading}
      />
      <button
        type="submit"
        disabled={loading}
        className="ml-2 p-2 rounded-full bg-black text-white hover:bg-gray-900 transition disabled:opacity-50"
      >
        <PaperAirplaneIcon className="h-4 w-4 -rotate-45" />
      </button>
    </form>
  );
};

export default PeopleSearchBox;
